<mat-card *ngIf="isSettingVisibile" class="src-room-control-mode">
  <div>
    <div class="mb-4">
      <div class="flex items-center gap-1">
        <h2 class="src-room-control-mode__title">{{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.TITLE' | translate }}</h2>
        <mat-icon class="src-room-control-mode__info-icon" (click)="openRoomModeModal()"> info_outline </mat-icon>
      </div>
      <span>{{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.DESCRIPTION' | translate }}</span>
    </div>
    <div class="room-control-mode__dropdown-wrapper">
      <span class="mr-2">{{
        '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.LABEL' | translate
      }}</span>
      <mat-form-field
        mat-select-height-small
        class="inline src-room-control-mode__form-field"
        data-at-room-control-mode-dropdown
        gtm="onChange"
        gtmAction="select all room control mode"
        gtmCategory="room"
      >
        <mat-select [value]="selectedControlMode" (valueChange)="onControlModeChange($event)">
          <mat-option *ngFor="let mode of availableControlModes" [value]="mode">
            {{ mode | translateRoomControlMode }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-error *ngIf="isAtleaseOneRoomIsDisabled">
        {{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.LIST.DISABLED' | translate }}
      </mat-error>
    </div>
  </div>
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>
            <mat-checkbox
              [checked]="this.isSelectAllChecked"
              [indeterminate]="isIndeterminate"
              (change)="onSelectAllCheckboxChange($event)"
            ></mat-checkbox>
          </th>
          <th>
            {{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.LIST.ROOM_LABEL' | translate }}
          </th>
          <th>
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.LIST.OPERATING_MODE_LABEL'
                | translate
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let room of rooms">
          <tr [class.disabled]="room.isDisabled" (click)="onRowClick(room)">
            <th>
              <mat-checkbox
                [checked]="room.isSelected"
                [disabled]="room.isDisabled"
                (click)="$event.stopPropagation()"
                (change)="onRoomCheckboxChange($event, room)"
              ></mat-checkbox>
            </th>
            <td>{{ room.roomDetails.properties?.name?.value }}</td>
            <td>
              {{ (room.roomControlMode.properties?.value?.value ?? noValue) | translateRoomControlMode }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="flex justify-end">
    <button
      class="room-control-mode__save-btn"
      data-at-demo-settings
      mat-raised-button
      [disabled]="isDisableSave"
      color="primary"
      gtm="onClick"
      gtmAction="Save control modes"
      gtmCategory="room control modes"
      (click)="onSave()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </div>
</mat-card>
